var map = {
	"./Actions.svg": 844,
	"./ActionsFill.svg": 845,
	"./Analytics.svg": 846,
	"./AnalyticsFill.svg": 847,
	"./ArrowDown.svg": 848,
	"./ArrowDownFill.svg": 849,
	"./ArrowIncoming.svg": 850,
	"./ArrowIncomingFill.svg": 851,
	"./ArrowLightLeft.svg": 852,
	"./ArrowLightRight.svg": 853,
	"./ArrowMinDown.svg": 854,
	"./ArrowMinLeft.svg": 855,
	"./ArrowMinRight.svg": 856,
	"./ArrowMinTop.svg": 857,
	"./ArrowOutgoing.svg": 858,
	"./ArrowOutgoingFill.svg": 859,
	"./ArrowSimpleDown.svg": 860,
	"./ArrowSimpleLeft.svg": 861,
	"./ArrowSimpleRight.svg": 862,
	"./ArrowSimpleUp.svg": 863,
	"./Barcode.svg": 864,
	"./Blockchain.svg": 865,
	"./Board.svg": 866,
	"./BoardFill.svg": 867,
	"./Boolean.svg": 868,
	"./Bot.svg": 869,
	"./Bullets.svg": 870,
	"./BulletsFill.svg": 871,
	"./Calculator.svg": 872,
	"./Calendar.svg": 873,
	"./CalendarFill.svg": 874,
	"./Camera.svg": 875,
	"./CameraFill.svg": 876,
	"./CheckCircle.svg": 877,
	"./CheckCircleFill.svg": 878,
	"./CheckShield.svg": 879,
	"./CheckboxChecked.svg": 880,
	"./CheckboxDropdown.svg": 881,
	"./CheckboxMinus.svg": 882,
	"./CheckboxOff.svg": 883,
	"./CheckboxOn.svg": 884,
	"./CircleActions.svg": 885,
	"./CircleActionsFill.svg": 886,
	"./CircleArrowDown.svg": 887,
	"./CircleArrowDownFill.svg": 888,
	"./CircleArrowLeft.svg": 889,
	"./CircleArrowLeftFill.svg": 890,
	"./CircleArrowRight.svg": 891,
	"./CircleArrowRightFill.svg": 892,
	"./CircleArrowUp.svg": 893,
	"./CircleArrowUpFill.svg": 894,
	"./CircleCross.svg": 895,
	"./CircleCrossFill.svg": 896,
	"./CircleDoc.svg": 897,
	"./CircleDocFill.svg": 898,
	"./CircleDownload.svg": 899,
	"./CircleDownloadFill.svg": 900,
	"./CircleEuro.svg": 901,
	"./CircleEuroFill.svg": 902,
	"./CircleGraph.svg": 903,
	"./CircleGraphFill.svg": 904,
	"./CircleInfo.svg": 905,
	"./CircleInfoFill.svg": 906,
	"./CircleLink.svg": 907,
	"./CircleLinkFill.svg": 908,
	"./CircleLocation.svg": 909,
	"./CircleLocationFill.svg": 910,
	"./CircleMinus.svg": 911,
	"./CircleMinusFill.svg": 912,
	"./CirclePacklockFill.svg": 913,
	"./CirclePadlock.svg": 914,
	"./CirclePen.svg": 915,
	"./CirclePenFill.svg": 916,
	"./CirclePicture.svg": 917,
	"./CirclePictureFill.svg": 918,
	"./CirclePlay.svg": 919,
	"./CirclePlayFill.svg": 920,
	"./CirclePlus.svg": 921,
	"./CirclePlusFill.svg": 922,
	"./CircleProfile.svg": 923,
	"./CircleProfileFill.svg": 924,
	"./CircleSearch.svg": 925,
	"./CircleSearchFill.svg": 926,
	"./CircleSetting.svg": 927,
	"./CircleSettingFill.svg": 928,
	"./CircleStar.svg": 929,
	"./CircleStarFill.svg": 930,
	"./CircleStop.svg": 931,
	"./CircleStopFill.svg": 932,
	"./CircleTick.svg": 933,
	"./CircleTickFill.svg": 934,
	"./Clipboard.svg": 935,
	"./ClipboardCheck.svg": 936,
	"./ClipboardTick.svg": 937,
	"./Clock.svg": 938,
	"./ClockDashed.svg": 939,
	"./Cloud.svg": 940,
	"./CloudFill.svg": 941,
	"./Code.svg": 942,
	"./Cog.svg": 943,
	"./CogFill.svg": 944,
	"./Conclusion.svg": 945,
	"./ConclusionFill.svg": 946,
	"./Condition.svg": 947,
	"./ConditionFill.svg": 948,
	"./Counter.svg": 949,
	"./CounterFill.svg": 950,
	"./Cross.svg": 951,
	"./Doc.svg": 952,
	"./DocDownload.svg": 953,
	"./DocDownloadFill.svg": 954,
	"./DocDuplicate.svg": 955,
	"./DocDuplicateFill.svg": 956,
	"./DocEmpty.svg": 957,
	"./DocEmptyFill.svg": 958,
	"./DocEuro.svg": 959,
	"./DocEuroFill.svg": 960,
	"./DocEye.svg": 961,
	"./DocEyeFill.svg": 962,
	"./DocFill.svg": 963,
	"./DocGraph.svg": 964,
	"./DocGraphFill.svg": 965,
	"./DocInfo.svg": 966,
	"./DocInfoFill.svg": 967,
	"./DocKey.svg": 968,
	"./DocKeyFill.svg": 969,
	"./DocLink.svg": 970,
	"./DocLinkFill.svg": 971,
	"./DocLocation.svg": 972,
	"./DocLocationFill.svg": 973,
	"./DocMinus.svg": 974,
	"./DocMinusFill.svg": 975,
	"./DocMultiply.svg": 976,
	"./DocMultiplyFill.svg": 977,
	"./DocPadlock.svg": 978,
	"./DocPadlockFill.svg": 979,
	"./DocPadlockOpen.svg": 980,
	"./DocPadlockOpenFill.svg": 981,
	"./DocPen.svg": 982,
	"./DocPenFill.svg": 983,
	"./DocPerson.svg": 984,
	"./DocPersonFill.svg": 985,
	"./DocPlay.svg": 986,
	"./DocPlayFill.svg": 987,
	"./DocPlus.svg": 988,
	"./DocPlusFill.svg": 989,
	"./DocSearch.svg": 990,
	"./DocSearchFill.svg": 991,
	"./DocSetting.svg": 992,
	"./DocSettingFill.svg": 993,
	"./DocStar.svg": 994,
	"./DocStarFill.svg": 995,
	"./DocStop.svg": 996,
	"./DocStopFill.svg": 997,
	"./DocTick.svg": 998,
	"./DocTickFill.svg": 999,
	"./DocUpload.svg": 1000,
	"./DocUploadFill.svg": 1001,
	"./DoubleArrowDown.svg": 1002,
	"./DoubleArrowLeft.svg": 1003,
	"./DoubleArrowRight.svg": 1004,
	"./DoubleArrowUp.svg": 1005,
	"./Download.svg": 1006,
	"./Drag.svg": 1007,
	"./Duplicate.svg": 1008,
	"./DuplicateFill.svg": 1009,
	"./Envelope.svg": 1010,
	"./Erase.svg": 1011,
	"./Euro.svg": 1012,
	"./Eye.svg": 1013,
	"./EyeCrossed.svg": 1014,
	"./Filter.svg": 1015,
	"./FilterFill.svg": 1016,
	"./Flag.svg": 1017,
	"./FlagFill.svg": 1018,
	"./FlagFull.svg": 1019,
	"./Forbidden.svg": 1020,
	"./Globe.svg": 1021,
	"./Graph.svg": 1022,
	"./GraphFill.svg": 1023,
	"./GraphLine.svg": 1024,
	"./Group.svg": 1025,
	"./GroupFill.svg": 1026,
	"./Handshake.svg": 1027,
	"./HandshakeFill.svg": 1028,
	"./House.svg": 1029,
	"./HouseFill.svg": 1030,
	"./IdFill.svg": 1031,
	"./IdLight.svg": 1032,
	"./Input.svg": 1033,
	"./InputFill.svg": 1034,
	"./Investors.svg": 1035,
	"./InvestorsFill.svg": 1036,
	"./Key.svg": 1037,
	"./KeyFill.svg": 1038,
	"./KeyHorizontal.svg": 1039,
	"./Layout.svg": 1040,
	"./LightArrowDown.svg": 1041,
	"./LightArrowDropdown.svg": 1042,
	"./LightArrowLeft.svg": 1043,
	"./LightArrowRight.svg": 1044,
	"./LightArrowUp.svg": 1045,
	"./Link.svg": 1046,
	"./LinkFill.svg": 1047,
	"./LinkHorizontal.svg": 1048,
	"./LinkLight.svg": 1049,
	"./List.svg": 1050,
	"./Location.svg": 1051,
	"./LocationFill.svg": 1052,
	"./Loupe.svg": 1053,
	"./Mail.svg": 1054,
	"./MailFill.svg": 1055,
	"./Meeting.svg": 1056,
	"./MeetingFill.svg": 1057,
	"./Menu.svg": 1058,
	"./Moon.svg": 1059,
	"./MoonFill.svg": 1060,
	"./OrderedList.svg": 1061,
	"./Package.svg": 1062,
	"./PadlockClose.svg": 1063,
	"./PadlockCloseFill.svg": 1064,
	"./PadlockOpen.svg": 1065,
	"./PadlockOpenFill.svg": 1066,
	"./Paperclip.svg": 1067,
	"./Pen.svg": 1068,
	"./Person.svg": 1069,
	"./PersonFill.svg": 1070,
	"./Phone.svg": 1071,
	"./Picture.svg": 1072,
	"./Plus.svg": 1073,
	"./Presentation.svg": 1074,
	"./PresentationFill.svg": 1075,
	"./QRcode.svg": 1076,
	"./QRcodeFill.svg": 1077,
	"./Question.svg": 1078,
	"./QuestionFill.svg": 1079,
	"./RadioButtonOff.svg": 1080,
	"./RadioButtonOn.svg": 1081,
	"./RadioDropdown.svg": 1082,
	"./ReplaceFile.svg": 1083,
	"./ReplaceFileFill.svg": 1084,
	"./Reset.svg": 1085,
	"./Reset2.svg": 1086,
	"./Review.svg": 1087,
	"./Ruler.svg": 1088,
	"./RulerFill.svg": 1089,
	"./Save.svg": 1090,
	"./Savings.svg": 1091,
	"./SavingsFill.svg": 1092,
	"./Scales.svg": 1093,
	"./ScalesFill.svg": 1094,
	"./Search.svg": 1095,
	"./Settings.svg": 1096,
	"./SettingsFill.svg": 1097,
	"./Shield.svg": 1098,
	"./ShieldFill.svg": 1099,
	"./Signout.svg": 1100,
	"./SortArrows.svg": 1101,
	"./Speech.svg": 1102,
	"./SpeechFill.svg": 1103,
	"./Star.svg": 1104,
	"./StarFill.svg": 1105,
	"./Stop.svg": 1106,
	"./Table.svg": 1107,
	"./TableColumns.svg": 1108,
	"./TableColumnsFill.svg": 1109,
	"./TableFill.svg": 1110,
	"./Tag.svg": 1111,
	"./TagFill.svg": 1112,
	"./Temperature.svg": 1113,
	"./TemperatureFill.svg": 1114,
	"./TextParaBig.svg": 1115,
	"./TextParaSmall.svg": 1116,
	"./Tick.svg": 1117,
	"./Ticket.svg": 1118,
	"./TicketFill.svg": 1119,
	"./Timeline.svg": 1120,
	"./TimelineFill.svg": 1121,
	"./ToggleButtonOff.svg": 1122,
	"./ToggleButtonOn.svg": 1123,
	"./Trace.svg": 1124,
	"./TraceFill.svg": 1125,
	"./Trail.svg": 1126,
	"./TrailFill.svg": 1127,
	"./Trash.svg": 1128,
	"./TrashFill.svg": 1129,
	"./Update.svg": 1130,
	"./Upload.svg": 1131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 843;